import React from "react";
import "./hidayet-section-box.scss";
import EasyButton from "../../components/easy-button";
interface HidayetSectionBoxProps {
    boxTitle: any;
    buttonTitle: string;
    summaryDescription: any;
    boxNumber: number;
    onClickSectionBox: Function;
}


const HidayetSectionBox = (props: HidayetSectionBoxProps) => {
    const onClickHandler = () => {
        if (props.onClickSectionBox) {
            props.onClickSectionBox(props.boxNumber)
        }
    }

    return (
        <div className="hidayet-section-box">
            <div className="section-box__name">{props.boxTitle}</div>

            <div className="section-box__summary-description">
                {props.summaryDescription}
            </div>
            <EasyButton title={props.buttonTitle} onClick={onClickHandler} />
        </div>
    )
}

export default HidayetSectionBox;